// @flow
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import Attributes from 'esm-web-pro/components/layout/sidePanel/Attributes';


type Props = {
    user: Object,
};

const UsersAttributes = (props: Props) => {
    const { user } = props;
    const orgUnits = user?.org_unit;
    const system = user?.systems[0].system.name;
    const attributes = [
        {
            label: <FormattedMessage id="authorization-users-systems" defaultMessage="Systems" />,
            value: system,
        },
        {
            label: <FormattedMessage
                id="authorization-users-organisationalunit"
                defaultMessage="Organisational Unit"
            />,
            value: orgUnits && orgUnits.map((ou) => ou.name).join(', '),
        },
    ];

    return <Attributes attributes={attributes} />;
};

export default UsersAttributes;
